import { getPageProps } from '@kibt/krn-utils';
import { useEffect, useRef } from 'react';
import { NativeModules } from 'react-native';
export function useSlideBack(initialEnable) {
    const enableRef = useRef(null);
    function setSlideBack(enabled) {
        var _a, _b;
        if (!!enabled === enableRef.current)
            return;
        enableRef.current = !!enabled;
        (_b = (_a = NativeModules === null || NativeModules === void 0 ? void 0 : NativeModules.KRNBasic) === null || _a === void 0 ? void 0 : _a.setSlideBack) === null || _b === void 0 ? void 0 : _b.call(_a, {
            enabled: enableRef.current, //  true: 打开滑动返回  false ：关闭滑动返回
            rootTag: getPageProps().rootTag, // 可选
        });
    }
    useEffect(() => {
        if (typeof initialEnable === 'boolean') {
            setSlideBack(initialEnable);
        }
    }, []);
    return {
        setSlideBack,
    };
}
